import { gql, useMutation } from '@apollo/client';

// GraphQL mutation
const DELETE_NOTE_MUTATION = gql`
  mutation DeleteNote($noteUuid: String!) {
    deleteNote(noteUuid: $noteUuid) {
      result
      nodesDeleted
      relationshipsDeleted
    }
  }
`;

export function useDeleteNote() {
  const [deleteNote, { data, loading, error, reset }] =
    useMutation(DELETE_NOTE_MUTATION);

  return {
    data,
    deleteNote,
    loading,
    error,
    reset,
  };
}
